import { render } from "./Meie.vue?vue&type=template&id=37d44d35&scoped=true"
const script = {}

import "./Meie.vue?vue&type=style&index=0&id=37d44d35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d44d35"]])

export default __exports__